exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PillGroup-808ed0a2.inline-e9764ca1{display:inline-block}.groupItem-fa857121{display:inline-block;padding:0 8px;border-radius:3px;font-weight:500;color:#FA6400;cursor:pointer;margin-right:5px}.groupItem-fa857121.selected-77a6d42f{color:#FFF;background:#FA6400}\n", ""]);

// Exports
exports.locals = {
	"PillGroup": "PillGroup-808ed0a2",
	"inline": "inline-e9764ca1",
	"groupItem": "groupItem-fa857121",
	"selected": "selected-77a6d42f"
};